/**
 * Convención admin: títulos y opciones de ngb-toast unificados.
 * El template muestra `textOrTpl` como título (h6) y `caption` como cuerpo.
 */

export type AdminToastKind = 'success' | 'error' | 'attention';

export const ADMIN_TOAST_TITLE: Record<AdminToastKind, string> = {
  success: 'Éxito',
  error: 'Error',
  attention: 'Atención',
};

/** Clases Bootstrap + posición; delay en ms. */
export const ADMIN_TOAST_DEFAULTS = {
  success: {
    classname: 'bg-success text-light toast-top-right',
    delay: 3000,
  },
  error: {
    classname: 'bg-danger text-light toast-top-right',
    delay: 4000,
  },
  attention: {
    classname: 'bg-warning text-dark toast-top-right',
    delay: 4000,
  },
} as const satisfies Record<AdminToastKind, { classname: string; delay: number }>;
